export { default as Filtration } from "./main";

import routes from "./routes";
import * as Anchors from "./anchors";
export default {
  routes,
  Anchors,
};
